import { getLocalizedUrl, alreadySignedUp, questionnaireCompleted, getRouteByKey } from "../../globals";
import { html } from "lit-html";
import i18next from "i18next";
import { useQueryState } from "GlobalShared/haunted/CustomHooks";
import { getTenantLabel } from "GlobalShared/helpers/tenantHelper";
import { navigateTo } from "GlobalShared/router";
export function AdminHome() {
  const [isNewCompany] = useQueryState("newcompany", false);
  const welcomeTemplate = () => html`
			<div class="flex flex-col items-center">
				<div class="text-2xl font-bold text-brand-primary py-8">${i18next.t("Fill out the Questionnaire")}</div>
				<div class="mb-2 text-left w-full px-8 max-w-screen-lg font-semibold leading-8">
					${i18next.t("Thank you for signing up for {{tenantLabel}} registration and compliance services.", { tenantLabel: getTenantLabel(ClientContext.TenantName) })}
				</div>
				<div class="mb-2 text-left w-full px-8 max-w-screen-lg font-semibold leading-8">
					${i18next.t("You will shortly receive a welcome email from your dedicated {{tenantLabel}} account manager; please feel free to contact them with any questions you might have.", {
    tenantLabel: getTenantLabel(ClientContext.TenantName)
  })}
				</div>
				<div class="mb-2 text-left w-full px-8 max-w-screen-lg font-semibold leading-8">
					${i18next.t(
    "To get started, you should provide details of your business by completing the Seller questionnaire on the next pages. This information is required to set you up as a {{tenantLabel}} client, issue your invoice as well as to register you. Each page must be completed before progressing to the next page and you can review your answers at the end before submitting them.",
    { tenantLabel: getTenantLabel(ClientContext.TenantName) }
  )}
				</div>
				<div class="mb-2 text-left w-full px-8 max-w-screen-lg font-semibold leading-8">
					${i18next.t(
    "We estimate that the questionnaire will take approximately 20 minutes to complete. To be able to answer all questions, we suggest having the following documents to hand:"
  )}
				</div>
				<ul class="ml-6 px-8" style="list-style-type:disc;">
					<li class="mb-2 text-left w-full max-w-screen-lg font-semibold leading-8">${i18next.t("Business incorporation documents (if appropriate)")}</li>
					<li class="mb-2 text-left w-full max-w-screen-lg font-semibold leading-8">${i18next.t("Passport/ID of the legal representative of the business")}</li>
					<li class="mb-2 text-left w-full max-w-screen-lg font-semibold leading-8">${i18next.t("VAT registration certificate for your home country (if appropriate)")}</li>
					<li class="mb-2 text-left w-full max-w-screen-lg font-semibold leading-8">${i18next.t("A bank statement showing your bank account information (if appropriate)")}</li>
				</ul>
				<div class="mb-2 text-left w-full px-8 max-w-screen-lg font-semibold leading-8">
					${i18next.t("If you are unsure how to answer a question, please contact us on {{- contactEmail}} e-mail address.", { contactEmail: ClientContext.ContactEmailAddress })}
				</div>
				<button
					class="btn btn-primary mt-8"
					@click=${() => {
    window.location.href = getLocalizedUrl("/admin/business-details");
  }}
				>
					${i18next.t("Start Questionnaire")}
				</button>
			</div>
		`;
  const signupTemplate = () => html`<ww-admin-signup></ww-admin-signup>`;
  const redirectToServicesPage = () => window.location.href = getLocalizedUrl("/admin/services");
  const redirectToContactPage = () => window.location.href = getLocalizedUrl("/contact");
  const newCompanyTemplate = () => ClientContext.CompanyInformation.IsNewOrderAllowed ? signupTemplate() : redirectToContactPage();
  const alreadySignedUpTemplate = () => questionnaireCompleted() ? redirectToServicesPage() : welcomeTemplate();
  const notSignedUpTemplate = () => ClientContext.CompanyInformation.IsNewOrderAllowed ? signupTemplate() : redirectToContactPage();
  const existingCompanyTemplate = () => alreadySignedUp() ? alreadySignedUpTemplate() : notSignedUpTemplate();
  const isNewCompanyTemplate = () => {
    if (ClientContext.IsPspUser) {
      return navigateTo(getRouteByKey("admin/cesop/periods"));
    }
    return isNewCompany ? newCompanyTemplate() : existingCompanyTemplate();
  };
  return html` <div class="m-2">${isNewCompanyTemplate()}</div> `;
}
